import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/obituary-fe/comps/FramedContentComp.jsx");
